import { publicAxios } from './api';

export async function forgotPassword({ email }: { email: string }) {
  const response = await publicAxios.post('/forgot-password', { email });
  return response.data;
}
/* istanbul ignore next */ /* this file is not used or will be deleted in other branches */
export async function changePasswordByToken({
  confirmPassword,
  password,
  token
}: {
  password: string;
  confirmPassword: string;
  token: string;
}) {
  const response = await publicAxios.post('/change-password-by-token', { confirmPassword, password, token });
  return response.data;
}
